import React from "react"
import { Link } from "gatsby"

type Props = {
  /** One-line context for *why* the reader should care, tailored to the page. */
  context: string
}

const IntegrationGuideStripe: React.FC<Props> = ({ context }) => (
  <section className="bg-white py-14 md:py-16">
    <div className="pm-container">
      <div className="mx-auto max-w-5xl rounded-2xl border border-purple-100 bg-gradient-to-br from-purple-50/60 via-white to-pink-50/60 p-8 md:p-10">
        <div className="flex flex-col gap-6 md:flex-row md:items-center md:justify-between">
          <div className="md:max-w-2xl">
            <p className="mb-2 text-xs font-semibold uppercase tracking-[0.18em] text-[#7253F5]">
              Works with your stack
            </p>
            <h3 className="mb-2 text-xl font-bold text-[#1F0F61] md:text-2xl">
              {context}
            </h3>
            <p className="text-gray-600 leading-relaxed">
              Our integration guide walks through the data sync, the widgets
              you can embed, and what your attendees see at every step.
            </p>
          </div>
          <Link
            to="/integrations/how-it-works/"
            className="inline-flex items-center gap-2 self-start whitespace-nowrap text-base font-semibold text-[#2b4bc3] transition-colors hover:text-[#1F0F61] md:self-auto"
          >
            Read the integration guide
            <span aria-hidden>→</span>
          </Link>
        </div>
      </div>
    </div>
  </section>
)

export default IntegrationGuideStripe
